import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "../../../components/GenericComponent/UploadMultiFile1";
import { convertToNumber } from "utils/numberExtension";
import { ThongTinChoVay } from "./ThongTinChoVay";
import { pushNotification } from "utils/notifications";
import CustomerForm from "components/CommonComponent/CustomerForm";
import NumberInput from "components/GenericComponent/NumberInput";

const ThemMoiBanHangTraGop = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    nguonkhachhang,
    postTraGop,
    onHide,
    cauhinh,
    getDetailCustomer,
    themmoitragop,
    setChoVayEdit,
    phanquyen,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
    setIsTraGopReturn,
    SuDungPhiPhat_DongLai_TatToan,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let {
    ConfigTMTG,
    choVayEdit,
    setListPhiKhac,
    postTraGopLoading,
    postTraGopReturn,
    TaiSanTraGop,
    isShowFormTraGop,
  } = themmoitragop;
  let NoteTaiSan = TaiSanTraGop.Note;
  let AnhTaiSan = TaiSanTraGop.AnhTaiSan;
  let { objConfig } = cauhinh;
  let objConfigSysLoaiTS = ConfigTMTG;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,
    IsDuNoGiamDan,
    ValueLai,
    LinkDinhKem,
    StatusPaidHo,
    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    LoaiPhiPhatTatToan,
  } = choVayEdit;
  IsEditChoVay = !IsEditChoVay;
  const [imgCusOld, setImgCusOld] = useState("");
  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [anhTaiSan, setAnhTaiSan] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [curentNoteTaiSan, setCurentNoteTaiSan] = useState([]);
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [currentCode, setCode] = useState(null);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
    NoteTaiSan: NoteTaiSan,
    Code: Code,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};
  useEffect(() => {
    if (choVayEdit.ChoVayId == undefined || choVayEdit.ChoVayId == 0) {
      choVayEdit.LoaiPhiPhatTraLai = intLoaiPhiPhatTraLai;
      choVayEdit.LoaiPhiPhatTatToan = intLoaiPhiPhatTatToan;
    } else if (choVayEdit.ChoVayId > 0) {
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);
    }

    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.ValueLai !== ValueLai) {
      setValue("ValueLai", ValueLai);
      currentChoVay.ValueLai = ValueLai;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.TypePaid !== TypePaid
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }

    if (AnhTaiSan && AnhTaiSan !== anhTaiSan) {
      setAnhTaiSan(AnhTaiSan);
      setImageTaiSans(AnhTaiSan.split(";"));
    }
    if (curentNoteTaiSan && curentNoteTaiSan !== NoteTaiSan) {
      setCurentNoteTaiSan(curentNoteTaiSan);
      setValue("NoteTaiSan", NoteTaiSan);
    }
    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
  }, [
    currentChoVay,
    CountTypePaid,
    LaiSuat,
    TypePaid,
    KieuLaiSuat,
    Code,
    currentCode,
    showButtonIn,
    isSetPhiKhac,
    objListPhiKhac,
    AnhTaiSan,
    anhTaiSan,
    curentNoteTaiSan,
    NoteTaiSan,
    setValue,
    ValueLai,
    errors,
  ]);

  useEffect(() => {
    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon
        );
      }
    }

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon
        );
      }
    }
  });

  const onChangeAttNumberChoVay = (field) => (evt) => {
    var value = convertToNumber(evt.target.value); //evt.target.value.replace(",","")
    choVayEdit[field] = value;
    setValue(field, value);
    if (field === "Sotienvay") {
      choVayEdit.ValueHoaHong = (convertToNumber(evt.target.value) * 1.2) / 100;
      setValue("ValueHoaHong", choVayEdit.ValueHoaHong);
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setValue(field, evt.target.value);
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    if (evt.target.checked) {
      choVayEdit.TypePaid = 2;
    } else {
      choVayEdit.TypePaid = 1;
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeStatusPaidHo = () => (evt) => {
    choVayEdit.StatusPaidHo = parseInt(evt.target.value);
    setChoVayEdit(choVayEdit);
  };
  let { PhanQuyenTraGop } = phanquyen;
  let { chonngaygiaodich, laiho_sudungchoduyet, ChoPhepSuaMaHopDong } =
    PhanQuyenTraGop;
  const init = {
    Id: 0,
    IdChoVay: 0,
    IdSanPham: 0,
    IdGoi: 0,
    TienGoc: 0,
    TienTraGop: 0,
    KyHan: 0,
    PhanTramTraGop: 0,
    TienTraTruoc: 0,
  };
  const [dataGoiTraGop, setDataGoiTraGop] = useState(init);
  const onChangeTraGop = (field) => (e) => {
    setDataGoiTraGop({
      ...dataGoiTraGop,
      [field]: e,
    });
  };
  const onSubmit = (dataChoVay) => {
    if (dataGoiTraGop.IdSanPham === 0) {
      pushNotification("Bạn chưa chọn sản phẩm", "error", "TOP_RIGHT", 2000);
      return;
    } else if (dataGoiTraGop.IdGoi === 0) {
      pushNotification("Bạn chưa chọn sản phẩm", "error", "TOP_RIGHT", 2000);
      return;
    }
    dataChoVay.ImageList = imageTaiSans.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });
    if (dataChoVay.StatusPaidHo == undefined || dataChoVay.StatusPaidHo == 0)
      dataChoVay.StatusPaidHo = choVayEdit.StatusPaidHo;

    dataChoVay.TypePaid = choVayEdit.TypePaid;
    dataChoVay.IsDuNoGiamDan = IsDuNoGiamDan;
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");

    if (
      typeof choVayEdit.ImgCusNewSave != "undefined" &&
      choVayEdit.imgCusOld === dataChoVay.customer.Img
    ) {
      dataChoVay.customer.Img = choVayEdit.ImgCusNewSave;
    } else {
      choVayEdit.imgCusOld = dataChoVay.customer.Img;
    }
    if (dataChoVay.BocTrongVong != undefined)
      dataChoVay.BocTrongVong = dataChoVay.BocTrongVong.replace(",", "");
    if (dataChoVay.CountTypePaid != undefined)
      dataChoVay.CountTypePaid = dataChoVay.CountTypePaid.replace(",", "");

    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;

    //
    dataChoVay.Sotienvay = convertToNumber(
      dataGoiTraGop.TienTraGop - dataGoiTraGop.TienTraTruoc
    );
    dataChoVay.StatusPaidHo = "2";
    dataChoVay.BocTrongVong = dataGoiTraGop.KyHan.toString();
    // dataChoVay.ValueLai = Math.round(
    //   convertToNumber(dataGoiTraGop.TienTraGop - dataGoiTraGop.TienTraTruoc) /
    //     dataGoiTraGop.KyHan
    // );
    dataChoVay.ValueLai = 0;
    dataChoVay.CountTypePaid = "1";
    dataChoVay.TypePaid = 2; //vay theo tháng
    postTraGop({
      ChoVay: dataChoVay,
      SanPhamTraGop: dataGoiTraGop,
      Customer: dataChoVay.customer,
      IsChoDuyet: laiho_sudungchoduyet,
    });
  };
  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    setChoVayEdit(choVayEdit);
    if (IsDuNoGiamDan !== undefined) {
      choVayEdit.NgayThanhToan = evt;
    }
  };
  const onChangeNgayThanhToan = (evt) => {
    choVayEdit.NgayThanhToan = evt;
    setChoVayEdit(choVayEdit);
  };

  const onChangePhiKhac = (configId) => (evt) => {
    if (evt.target.value != undefined) {
      objListPhiKhac[configId].GiaTri = evt.target.value;
      if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    }
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const closeThemMoi = () => () => {
    getDetailCustomerSuccess({});
    onHide();
  };
  if (postTraGopReturn) {
    onHide();
    setIsTraGopReturn();
    setImageTaiSans(choVayEdit.lstImgTaiSanSave.split(";"));
    setFileDinhKems(choVayEdit.ImgDinhKemSave.split(";"));
  }
  let { autocompleteData } = customer;
  let { combo } = user;
  let showLaiPhang = false;
  let showDuNoGiamDan = false;
  if (IsDuNoGiamDan !== undefined) {
    showLaiPhang = !IsDuNoGiamDan;
    showDuNoGiamDan = IsDuNoGiamDan;
  }
  console.log(choVayEdit, "choVayEditchoVayEditchoVayEditchoVayEditchoVayEdit");
  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <div
        className={
          "loader loader-default " + (postTraGopLoading ? "is-active" : "")
        }
      ></div>
      <form
        className="form tat-toan form-horizontal form-edit"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Modal.Header>
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
            </span>{" "}
            {ChoVayId > 0 ? "Cập nhật" : "Thêm mới"} hợp đồng
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeThemMoi()}
          >
            <img src="/app-assets/images/icon-dong-popup-v2.png" />
          </button>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "0px", background: "#F4F5FA !important" }}
        >
          <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse196"
                  className="card-header "
                  data-toggle="collapse"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin khách vay</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <CustomerForm
                    customerId={CustomerID}
                    currentForm={currentForm}
                    autocompleteData={autocompleteData}
                    getAutocompleteCustomer={getAutocompleteCustomer}
                    userCombo={combo}
                    comboNguonKhachHang={comboNguonKhachHang}
                    customer={customer}
                    getDetailCustomer={getDetailCustomer}
                    errors={errors}
                    IsEditCustomer={IsEditCustomer}
                    checkEditCustomer={checkEditCustomer}
                    setEnableEditCustomer={setEnableEditCustomer}
                    CodeCuaHang={thongTinCuaHang.Code}
                  ></CustomerForm>
                </div>
              </div>
            </div>
          </div>
          <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
            <div
              id="headingCollapse194"
              className="card-header  mt-1"
              data-toggle="collapse"
              href="#collapse194"
              aria-expanded="true"
              aria-controls="collapse194"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Thông tin cho vay</h3>
              </a>
            </div>
            <div
              id="collapse194"
              aria-labelledby="headingCollapse94"
              className="card-collapse collapse show"
              aria-expanded="true"
            >
              <div className="card-content">
                <div className="card-body">
                  <div className="row">
                    <input
                      type="hidden"
                      name="ChoVayId"
                      value={ChoVayId}
                      ref={register}
                    ></input>
                    <div className="col-md-12 col-lg-12">
                      <div className="row thongtinchovay-v2">
                        <ThongTinChoVay
                          func={{
                            onChangeNgayVay: onChangeNgayVay,
                            onChangeAttNumberChoVay: onChangeAttNumberChoVay,
                            onChangeTypePaid: onChangeTypePaid,
                            onChangeAttTextChoVay: onChangeAttTextChoVay,
                            onChangeStatusPaidHo: onChangeStatusPaidHo,
                            onChangeNgayThanhToan: onChangeNgayThanhToan,
                            setDataGoiTraGop: setDataGoiTraGop,
                          }}
                          data={choVayEdit}
                          dataGoi={dataGoiTraGop}
                          register={register}
                          chonngaygiaodich={chonngaygiaodich}
                          IsEditChoVay={IsEditChoVay}
                          control={control}
                          errors={errors}
                          config={ConfigTMTG}
                          ChoPhepSuaMaHopDong={ChoPhepSuaMaHopDong}
                        />
                        <div className="col-md-12"></div>
                        {SuDungPhiPhat_DongLai_TatToan && (
                          <>
                            <div className="col-md-4">
                              <NumberInput
                                labelClass="col-md-6 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-6"
                                labelText="Phạt chậm đóng lãi"
                                wrapperClass="form-group row"
                                inputProps={{
                                  name: "PhiPhatTraLai",
                                  value: PhiPhatTraLai,
                                  onChange:
                                    onChangeAttNumberChoVay("PhiPhatTraLai"),
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                              ></NumberInput>
                            </div>
                            <div className="col-md-4 radio-button-nhap-tien">
                              <label className="custom-radio">
                                <input
                                  type="radio"
                                  name="LoaiPhiPhatTraLai"
                                  onChange={onChangeLoaiPhiPhatTraLai(1)}
                                  checked={
                                    intLoaiPhiPhatTraLai === 1 ? true : false
                                  }
                                  disabled={IsEditChoVay}
                                />{" "}
                                <span className="radio-mark"></span>
                                Nhập tiền
                              </label>
                              <label className="custom-radio radio-button-nhap-phan-tram">
                                <input
                                  type="radio"
                                  name="LoaiPhiPhatTraLai"
                                  onChange={onChangeLoaiPhiPhatTraLai(2)}
                                  checked={
                                    intLoaiPhiPhatTraLai === 2 ? true : false
                                  }
                                  disabled={IsEditChoVay}
                                />{" "}
                                <span className="radio-mark"></span>
                                Nhập %
                              </label>
                            </div>
                              <div className="col-md-12"></div>
                            <div className="col-md-4">
                              <NumberInput
                                labelClass="col-md-6 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-6"
                                labelText="Phạt tất toán sớm"
                                wrapperClass="form-group row"
                                inputProps={{
                                  name: "PhiPhatTatToan",
                                  value: PhiPhatTatToan,
                                  onChange:
                                    onChangeAttNumberChoVay("PhiPhatTatToan"),
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                              ></NumberInput>
                            </div>
                            <div className="col-md-4 radio-button-nhap-tien">
                              <label className="custom-radio">
                                <input
                                  type="radio"
                                  name="LoaiPhiPhatTatToan"
                                  onChange={onChangeLoaiPhiPhatTatToan(1)}
                                  checked={
                                    intLoaiPhiPhatTatToan === 1 ? true : false
                                  }
                                  disabled={IsEditChoVay}
                                />{" "}
                                <span className="radio-mark"></span>
                                Nhập tiền
                              </label>
                              <label className="custom-radio radio-button-nhap-phan-tram">
                                <input
                                  type="radio"
                                  name="LoaiPhiPhatTatToan"
                                  onChange={onChangeLoaiPhiPhatTatToan(2)}
                                  checked={
                                    intLoaiPhiPhatTatToan === 2 ? true : false
                                  }
                                  disabled={IsEditChoVay}
                                />{" "}
                                <span className="radio-mark"></span>
                                Nhập %
                              </label>
                            </div>
                          </>
                        )}

                        <div className="col-md-12">
                          <label className="label-control color7-bold">
                            Ghi chú
                          </label>
                          <textarea
                            rows="1"
                            style={{ minHeight: "80px" }}
                            className="form-control input-sm"
                            name="Note"
                            placeholder=""
                            value={Note}
                            onChange={onChangeAttTextChoVay("Note")}
                            ref={register}
                            disabled={IsEditChoVay}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
            <div
              id="headingCollapse19412"
              className="card-header  mt-1"
              data-toggle="collapse"
              href="#collapse19412"
              aria-expanded="false"
              aria-controls="collapse194"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Các loại phí</h3>
              </a>
            </div>
            <div
              id="collapse19412"
              role="tabpanel"
              aria-labelledby="headingCollapse9412"
              className="card-collapse collapse"
            >
              <div className="card-content">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 col-lg-12">
                      {objListPhiKhac &&
                        objListPhiKhac.map((item, idx) => (
                          <div key={"phiKhac" + idx}>
                            <div className="row">
                              <div className="col-md-6">
                                <NumberInput
                                  labelClass="col-md-6 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-6"
                                  wrapperClass="form-group row"
                                  labelText={item.TenPhiKhac}
                                  inputProps={{
                                    name: "ListPhiKhac[" + idx + "].GiaTri",
                                    value: objListPhiKhac[idx].GiaTri,
                                    onChange: onChangePhiKhac(idx),
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                ></NumberInput>
                              </div>
                              <div className="col-md-6">
                                {item.LoaiPhiKhac == 1 ? (
                                  <>
                                    &nbsp;
                                    <br />
                                    <div
                                      className="col-md-12"
                                      style={{ paddingTop: "20px" }}
                                    >
                                      <label className="custom-radio">
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhac"
                                          }
                                          value="1"
                                          checked={true}
                                          disabled={true}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập tiền
                                      </label>
                                      <label
                                        className="custom-radio"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhac"
                                          }
                                          value="2"
                                          checked={false}
                                          disabled={true}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập %
                                      </label>
                                    </div>
                                  </>
                                ) : item.LoaiPhiKhac == 2 ? (
                                  <>
                                    &nbsp;
                                    <br />
                                    <div
                                      className="col-md-12"
                                      style={{ paddingTop: "20px" }}
                                    >
                                      <label className="custom-radio">
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhac"
                                          }
                                          value="1"
                                          checked={false}
                                          disabled={true}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập Tiền
                                      </label>
                                      <label
                                        className="custom-radio"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhac"
                                          }
                                          value="2"
                                          checked={true}
                                          disabled={true}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập %
                                      </label>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    &nbsp;
                                    <br />
                                    <div
                                      className="col-md-12"
                                      style={{ paddingTop: "20px" }}
                                    >
                                      <label className="custom-radio">
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhacChon"
                                          }
                                          value="1"
                                          checked={
                                            objListPhiKhac[idx]
                                              .LoaiPhiKhacChon === 1
                                              ? true
                                              : false
                                          }
                                          ref={register}
                                          disabled={IsEditChoVay}
                                          onChange={onChangeLoaiPhiKhac(idx, 1)}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập tiền
                                      </label>
                                      <label
                                        className="custom-radio"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        <input
                                          type="radio"
                                          name={
                                            "ListPhiKhac[" +
                                            idx +
                                            "].LoaiPhiKhacChon"
                                          }
                                          value="2"
                                          checked={
                                            objListPhiKhac[idx]
                                              .LoaiPhiKhacChon === 2
                                              ? true
                                              : false
                                          }
                                          ref={register}
                                          disabled={IsEditChoVay}
                                          onChange={onChangeLoaiPhiKhac(idx, 2)}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập %
                                      </label>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            <input
                              type="hidden"
                              name={"ListPhiKhac[" + idx + "].ConfigPhiKhacId"}
                              value={item.ConfigPhiKhacId}
                              ref={register}
                            />
                            <input
                              type="hidden"
                              name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                              value={item.LoaiPhiKhac}
                              ref={register}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              {objListPhiKhacHangKy != undefined &&
                objListPhiKhacHangKy.length > 0 && (
                  <>
                    <div
                      id="headingCollapse194121"
                      className="card-header  mt-1"
                      data-toggle="collapse"
                      href="#collapse194121"
                      aria-expanded="false"
                      aria-controls="collapse1941"
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Các loại phí hàng kỳ</h3>
                      </a>
                    </div>
                    <div
                      id="collapse194121"
                      role="tabpanel"
                      aria-labelledby="headingCollapse194121"
                      className="card-collapse collapse"
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12 col-lg-12">
                              {objListPhiKhacHangKy &&
                                objListPhiKhacHangKy.map((item, idx) => (
                                  <div key={"phiKhacHangKy" + idx}>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <NumberInput
                                          labelClass="col-md-6 label-control"
                                          inputClass="form-control input-sm"
                                          inputWrapClass="col-md-6"
                                          wrapperClass="form-group row"
                                          labelText={item.TenPhiKhacHangKy}
                                          inputProps={{
                                            name:
                                              "ListPhiKhacHangKy[" +
                                              idx +
                                              "].GiaTri",
                                            value:
                                              objListPhiKhacHangKy[idx].GiaTri,
                                            onChange:
                                              onChangePhiKhacHangKy(idx),
                                            control: control,
                                          }}
                                        ></NumberInput>
                                      </div>
                                      <div className="col-md-6">
                                        {item.LoaiPhiKhacHangKy == 1 ? (
                                          <>
                                            &nbsp;
                                            <br />
                                            <div
                                              className="col-md-12"
                                              style={{ paddingTop: "20px" }}
                                            >
                                              <label className="custom-radio">
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKy"
                                                  }
                                                  value="1"
                                                  checked={true}
                                                  disabled={true}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập tiền
                                              </label>

                                              <label
                                                className="custom-radio"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKy"
                                                  }
                                                  value="2"
                                                  checked={false}
                                                  disabled={true}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập %
                                              </label>
                                            </div>
                                          </>
                                        ) : item.LoaiPhiKhacHangKy == 2 ? (
                                          <>
                                            &nbsp;
                                            <br />
                                            <div
                                              className="col-md-12"
                                              style={{ paddingTop: "20px" }}
                                            >
                                              <label className="custom-radio">
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKy"
                                                  }
                                                  value="1"
                                                  checked={false}
                                                  disabled={true}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập tiền
                                              </label>
                                              <label
                                                className="custom-radio"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKy"
                                                  }
                                                  value="2"
                                                  checked={true}
                                                  disabled={true}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập %
                                              </label>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            &nbsp;
                                            <br />
                                            <div
                                              className="col-md-12"
                                              style={{ paddingTop: "20px" }}
                                            >
                                              <label className="custom-radio">
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKyChon"
                                                  }
                                                  value="1"
                                                  checked={
                                                    objListPhiKhacHangKy[idx]
                                                      .LoaiPhiKhacHangKyChon ===
                                                    1
                                                      ? true
                                                      : false
                                                  }
                                                  ref={register}
                                                  disabled={IsEditChoVay}
                                                  onChange={onChangeLoaiPhiKhacHangKy(
                                                    idx,
                                                    1
                                                  )}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập tiền
                                              </label>

                                              <label
                                                className="custom-radio"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].LoaiPhiKhacHangKyChon"
                                                  }
                                                  value="2"
                                                  checked={
                                                    objListPhiKhacHangKy[idx]
                                                      .LoaiPhiKhacHangKyChon ===
                                                    2
                                                      ? true
                                                      : false
                                                  }
                                                  ref={register}
                                                  disabled={IsEditChoVay}
                                                  onChange={onChangeLoaiPhiKhacHangKy(
                                                    idx,
                                                    2
                                                  )}
                                                />
                                                <span className="radio-mark"></span>
                                                Nhập %
                                              </label>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    <input
                                      type="hidden"
                                      name={
                                        "ListPhiKhacHangKy[" +
                                        idx +
                                        "].ConfigPhiKhacHangKyId"
                                      }
                                      value={item.ConfigPhiKhacHangKyId}
                                      ref={register}
                                    />
                                    <input
                                      type="hidden"
                                      name={
                                        "ListPhiKhacHangKy[" +
                                        idx +
                                        "].LoaiPhiKhacHangKy"
                                      }
                                      value={item.LoaiPhiKhacHangKy}
                                      ref={register}
                                    />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </div>
          </div>
          <div
            id="collapse19412"
            aria-labelledby="headingCollapse9412"
            className="card-collapse collapse"
            aria-expanded="true"
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                        Giấy tờ tín chấp
                      </label>
                      <div className="col-md-10">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="1 CMT + 1 GPLX"
                          name="NoteTaiSan"
                          ref={register}
                          readOnly={IsEditChoVay}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-md-2 label-control"></label>
                      <div className="col-md-10">
                        <UploadMultiFile
                          Files={imageTaiSans}
                          onChange={setImageTaiSans}
                          Code={thongTinCuaHang.Code}
                          readOnly={IsEditChoVay}
                        ></UploadMultiFile>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
          <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
            <div
              id="headingCollapse19412"
              className="card-header  mt-1"
              data-toggle="collapse"
              href="#collapse19413"
              aria-expanded="false"
              aria-controls="collapse19413"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Bổ sung giấy tờ tín chấp vay</h3>
              </a>
            </div>
            <div
              id="collapse19413"
              role="tabpanel"
              aria-labelledby="headingCollapse9412"
              className="card-collapse collapse"
            >
              <div className="card-content">
                <div className="card-body">
                  <div className="row">
                    <label class="col-md-4 color7-bold">Giấy tờ tín chấp</label>
                    <br />
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control input-sm"
                        placeholder="1 CMT + 1 GPLX"
                        name="NoteTaiSan"
                        ref={register}
                        readOnly={IsEditChoVay}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-12">
                      <UploadMultiFile
                        Files={imageTaiSans}
                        onChange={setImageTaiSans}
                        Code={thongTinCuaHang.Code}
                      ></UploadMultiFile>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
            <div
              id="headingCollapse191191"
              className="card-header  mt-1"
              data-toggle="collapse"
              href="#collapse191191"
              aria-expanded="false"
              aria-controls="collapse194"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Đính kèm file</h3>
              </a>
            </div>
            <div
              id="collapse191191"
              role="tabpanel"
              aria-labelledby="headingCollapse9412"
              className="card-collapse collapse"
            >
              <div className="card-content">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 col-lg-12">
                      <UploadMultiFile1
                        Files={fileDinhKems}
                        onChange={setFileDinhKems}
                        Code={thongTinCuaHang.Code}
                      ></UploadMultiFile1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <button className="btn btn-new-main btn-checknew" type="submit">
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            {laiho_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
          </button>
          {showButtonIn && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inHopDong(choVayEdit)}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In hợp đồng
            </button>
          )}

          {showButtonInPhieuThu && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inPhieuThu(ThuChiId)}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In phiếu thu
            </button>
          )}

          <button
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={closeThemMoi()}
            type="button"
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default ThemMoiBanHangTraGop;
